import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import ProgramCard from "./ProgramCard";
import ProgramViewMoreCard from "./ProgramViewMoreCard";
import LoadingAnimation from "../../../common/LoadingAnimation";

import { GetWholeWorkoutByProgram } from "../../../redux/v2/workout/actions";
import CustomTab from "../../../common/CustomTab";
import { removeDuplicates, removeItemInArray } from "../../../utils";

function ProgramsList(props) {
    const {
        User,
        programs,
        setSelectedProgram,
        selectedPrograms,
        addedProgram = [],
        screenSize,
        initialMaxItem = 4,
        displayType = 1, // 1 = actual program page listing, 2 = onboarding listing, 3 = resurvey listing, 4 = single list of not added programs
        choosenPrograms = [],
        choosenProgramIDs,
        title = null,
        programIsFull,
    } = props;
    const { account } = User;
    const location = useLocation();
    const displayTypes = ["", "YOUR PROGRAMS", "FOR YOU", "", ""];
    const displayList = [
        [],
        [
            { label: "YOUR PROGRAMS", gradient: " #d37536-#d37536", active: true },
            { label: "FOR YOU", gradient: " #d37536-#d37536", active: false },
            { label: "STRENGTH", gradient: "#8b1e3f-#8b1e3f", active: false },
            { label: "MOBILITY", gradient: "#6ba292-#6ba292", active: false },
            { label: "FOCUS", gradient: "#4a4064-#4a4064", active: false },
            { label: "ATHLETICS", gradient: "#daa520-#daa520", active: false },
        ],
        [
            { label: "FOR YOU", gradient: " #d37536-#d37536", active: true },
            { label: "STRENGTH", gradient: "#8b1e3f-#8b1e3f", active: false },
            { label: "MOBILITY", gradient: "#6ba292-#6ba292", active: false },
            { label: "FOCUS", gradient: "#4a4064-#4a4064", active: false },
            { label: "ATHLETICS", gradient: "#daa520-#daa520", active: false },
        ],
        { label: "YOUR PROGRAMS", gradient: " #d37536-#d37536", active: true },
        []
    ]
    const [maxItem, setMaxItem] = useState(initialMaxItem);
    const [currentTab, setCurrentTab] = useState(displayTypes[displayType || 0]);
    const [programTypes, setProgramTypes] = useState(displayList[displayType || 0]);

    const onboardingDetails = account?.onboardingDetails?.[account?.onboardingDetails?.length - 1];
    const programsInWP = onboardingDetails?.programs?.split(",") || [];

    useEffect(() => {
        if (programs.length > 0 && programTypes.length == 1) {
            // const types = programs.map(p => { return p.type + "|" + p.gradient });
            // const uTypes = Array.from(new Set(types));
            // const togglers = uTypes.map(ut => {
            //     let uts = ut.split("|")
            //     return {
            //         label: uts[0].toUpperCase(),
            //         gradient: uts[1],
            //         active: false
            //     }
            // })
            // setProgramTypes([
            //     ...programTypes,
            //     ...togglers
            // ]);
        }
    }, [programs.length]);

    const selected_program = User?.account?.user?.selected_program?.split(",") || selectedPrograms || [];
    let filteredList = [];
    let key, id, level;


    for (let x = 0; x < programs.length; x++) {
        id = programs[x]?.id;
        level = programs[x]?.level;

        key = id + "" + (level && level != 0 ? "-" + level : "");
        filteredList.push({
            ...programs[x],
            added: selected_program?.includes(key),
        });
    }

    const grid = screenSize == "xl" || screenSize == "lg" ? 4 : 6;
    let list = [];
    if (currentTab == "FOR YOU") {
        list = filteredList.filter((w, i) => !w?.added);
        list = list.filter((w, i) => i < maxItem);
    } else if (currentTab == "YOUR PROGRAMS") {
        list = filteredList.filter((w, i) => w?.added);
    } else if (displayType == 3) {
        list = filteredList.filter((w, i) => w?.added);
        list = list?.map((p) => {
            return {
                ...p,
                choosen: choosenProgramIDs.includes(p?.id + "-" + p?.level),
            };
        });
    } else if (displayType == 4) {
        filteredList = removeItemInArray(filteredList, [...addedProgram, ...choosenPrograms], ["id", "level"]);
        list = filteredList.filter((w, i) => !w?.added);
        list = list.filter((w, i) => i < maxItem);
    } else {
        list = filteredList.filter((w, i) => w.type == currentTab.toLowerCase());
    }

    const isInResurvey = location.pathname.includes("/user-survey");
    const isInOnboarding = location.pathname.includes("/user-onboarding");

    const fAddedProgram = removeDuplicates(addedProgram, ["id", "level"]);

    return (
        <div id="onb-v2-cards">
            {programTypes?.length > 0 && <div id="program-type-options">
                <CustomTab
                    tabs={programTypes}
                    onClick={(label, i) => {
                        let temp = [...programTypes];
                        for (let x = 0; x < temp.length; x++) {
                            temp[x] = {
                                ...temp[x],
                                active: temp[x].label == label,
                            };
                        }
                        setProgramTypes(temp);
                        setCurrentTab(label);
                    }}
                />
            </div>}

            <div id="onb-v2-cards-wrapper" className="row">
                {(title && !isInOnboarding) ? <div className="col-md-12" style={{ padding: "5px 30px" }}>
                    <h5 style={{ textAlign: "left" }}>{title}</h5>
                </div> : ""}
                {((!programs?.length) || (programs?.length == 0)) ? (
                    <div className="col-md-12" style={{ padding: "30px 0" }}>
                        <LoadingAnimation />
                    </div>
                ) : (
                    <>
                        {(currentTab == "FOR YOU" || displayType == 4) && fAddedProgram.map((program, i) => {
                            return (
                                <ProgramCard
                                    key={"pc-i-" + i}
                                    program={{ ...program, added: true }}
                                    grid={grid}
                                    onClick={() => {
                                        props.GetWholeWorkoutByProgram(program?.id, program?.level);
                                        setSelectedProgram(program);
                                    }}
                                    displayType={displayType}
                                />
                            );
                        })}

                        {list.map((program, i) => {
                            const programKey = program?.id + (program?.level ? ("-" + program?.level) : "");
                            return (
                                <ProgramCard
                                    key={"pc-i-" + i}
                                    program={program}
                                    grid={grid}
                                    onClick={() => {
                                        props.GetWholeWorkoutByProgram(program?.id, program?.level);
                                        setSelectedProgram(program);
                                    }}
                                    displayType={displayType}
                                    isInWP={programsInWP.includes(programKey)}
                                    programIsFull={programIsFull}
                                />
                            );
                        })}
                        {/* {
                                maxItem < unselected.length &&
                                <ProgramViewMoreCard
                                    key={"pc-i-100"}
                                    grid={grid}
                                    onClick={() => {
                                        setMaxItem(programs.length)
                                    }}
                                />
                            } */}
                    </>
                )}

                <div className="col-md-12" />
                <div className={`col-md-${grid}`} />

                {screenSize == "xl" && (
                    <>
                        <div className={`col-md-${grid}`} />
                        <div className={`col-md-${grid}`} />
                    </>
                )}
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Program: state.Program,
});

export default connect(mapStateToProps, {
    GetWholeWorkoutByProgram,
})(ProgramsList);
